import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function ExitIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 33 33"
      xmlSpace="preserve"
      enableBackground="new 0 0 33 33"
      titleAccess="Exit">
      <g filter="url(#filter0_d_6264_32748)">
        <ellipse cx={16.5003} cy={12.5} rx={11.8929} ry={11.8929} fill="#0A4842" />
      </g>
      <ellipse cx={16.4999} cy={12.5001} rx={7.92858} ry={7.92857} fill="#fff" />
      <ellipse cx={16.5004} cy={12.4999} rx={3.96429} ry={3.96429} fill="#0A4842" />
      <defs>
        <filter
          id="filter0_d_6264_32748"
          x={0.607422}
          y={0.607178}
          width={31.7861}
          height={31.7856}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6264_32748" />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6264_32748"
            result="shape"
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
